'use client';

import { getCoreRowModel, useReactTable } from '@tanstack/react-table';

import { ADMIN_OFFICE_COLUMNS } from '@/app/(app)/admin/offices/columns';
import { PageMain } from '@/app/(app)/page-main';
import { DataTable } from '@/components/data-table';
import { useApiV1Ctx } from '@/components/providers/v1-api';

export function AdminOfficesPage() {
  return (
    <PageMain title='Offices'>
      <div className='flex w-full items-center'>
        <div className='flex flex-col gap-1'>
          <h1 className='text-2xl font-bold'>Offices</h1>
          <p className='text-sm text-muted-foreground'>All offices in the system.</p>
        </div>
      </div>
      <Table />
    </PageMain>
  );
}

function Table() {
  const { api } = useApiV1Ctx();
  const { data } = api.offices.listAllOffices.useQuery();

  const table = useReactTable({
    data: data ?? [],
    columns: ADMIN_OFFICE_COLUMNS,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className='overflow-hidden rounded-md border'>
      <DataTable table={table} columns={ADMIN_OFFICE_COLUMNS} />
    </div>
  );
}
